module.exports = __webpack_public_path__ + "static/media/break-icon.07af1f37.svg";